import { defineComponent, ref, computed, watch } from 'vue';
import __vue_component__ from '../../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$1 from './ConfirmLogoutModal.vue.js';
import __vue_component__$2 from './UserBanner.vue.js';
import { useSharedNavBarLogic } from '../helper.js';
import __vue_component__$3 from '../../../symbols/X.vue.js';
import '../../../specific/portal/store/portal/sessionStore.js';
import '@caresend/utils';
import '@caresend/types';
import 'file-saver';
import '../../../../database/firebaseConfig/cloudFunctions.js';
import '../../../../database/encryption/model.js';
import 'js-sha256';
import { getStore } from '../../../../store/helpers/initStore.js';
import 'lodash.clonedeep';
import 'lodash.isequal';
import '../../../specific/portal/store/storeUtilities/dbSync/dbSyncStore.js';
import '../../../../store/modules/app/model.js';
import 'firebase/database';
import 'firebase/auth';
import '../../../../database/firebaseConfig/init.js';
import '../../../../database/firebaseConfig/methods.js';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';
import '../../../ui/Icon.vue.js';
import '../../../../functions/configuration/icons.js';
import '../../../../database/algoliaConfig/indices.js';
import 'mobile-device-detect';
import '../../../../functions/tracking/index.js';
import '../../../../router/helpers/initRouter.js';
import '@firebase/auth';
import 'browser-image-compression';
import 'firebase/storage';
import 'immutability-helper';
import '../../../../router/routes/dev/model.js';
import '../../../../router/routes/dev/routes.js';
import '../../../../router/routes/dashboard/model.js';
import '../../../../router/routes/pro/model.js';
import '../../../../router/routes/visitsPage/model.js';
import '../../../../router/routes/orderFlow/model.js';
import '../../../../router/routes/orderFlow/privateHelpers.js';
import '../../../../router/routes/orderFlow/routes.js';
import '../../../../router/routes/schedulingFlow/model.js';
import '../../../../router/routes/schedulingFlow/routes.js';
import '../../../../router/routes/chartingFlow/model.js';
import '../../../../router/routes/chartingFlow/routes.js';
import '../../../../router/routes/portal/portalRoutes.js';
import '../../../../router/routes/portal/model.js';
import '../../../../router/routes/visitsPage/routes.js';
import '../../../specific/dev/AdvancedSettings/subViews/FeatureFlags/model.js';
import '../../../../store/modules/auth/index.js';
import 'dayjs';
import '../../../../store/modules/chartingFlow/chartingFlowSteps/steps.js';
import '../../../../store/modules/chartingFlow/model.js';
import '../../../../store/modules/office/index.js';
import '../../../specific/VisitsPage/subComponents/OrdersVisitsFilters/model.js';
import '../../../../store/modules/office/model.js';
import '../../../../store/modules/orderFlow/index.js';
import '../../../../store/modules/procedures/model.js';
import '../../../../store/modules/schedulingFlow/index.js';
import '../../../../store/modules/schedulingFlow/model.js';

var script = defineComponent({
    name: 'SideMenu',
    components: {
        ButtonComponent: __vue_component__,
        ConfirmLogoutModal: __vue_component__$1,
        UserBanner: __vue_component__$2,
        X: __vue_component__$3,
    },
    props: {
        isLogoutModalOpened: Boolean,
        isSideMenuOpened: Boolean,
        logInRoute: {
            type: Object,
            required: true,
        },
        navItems: {
            type: Array,
            required: true,
        },
    },
    setup(props, { emit }) {
        const store = getStore();
        const isOpened = ref(props.isSideMenuOpened);
        const { isLoggedIn } = useSharedNavBarLogic();
        const classNames = computed(() => {
            const names = [];
            if (isLoggedIn.value) {
                names.push('SideMenu--is-logged-in');
            }
            return names;
        });
        watch(() => props.isSideMenuOpened, (next) => { isOpened.value = next; });
        watch(() => isOpened.value, (next) => emit('changeOpenValue', next));
        const handleMenuItemClicked = (itemClick, keepMenuOpened = false) => {
            if (!keepMenuOpened)
                isOpened.value = false;
            return itemClick === null || itemClick === void 0 ? void 0 : itemClick();
        };
        const menuInfo = computed(() => store.getters['app/getMenuInfo']);
        /**
         * For office staff, the email address is used as secondary info. We always
         * display the email address in the mobile menu, so we should hide the
         * secondary info if it matches the email address.
         */
        const showSecondaryInfo = computed(() => { var _a, _b; return ((_a = menuInfo.value) === null || _a === void 0 ? void 0 : _a.secondary) !== ((_b = menuInfo.value) === null || _b === void 0 ? void 0 : _b.email); });
        return {
            ...useSharedNavBarLogic(),
            classNames,
            handleMenuItemClicked,
            isOpened,
            menuInfo,
            showSecondaryInfo,
        };
    },
});

export { script as default };
